import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { useAssetCopierContext } from '../providers/AssetCopierProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssetCopierPanelFooter(props) {
  const {
    currentStep,
    goToNextStep,
    setCurrentStep,
    selectedTargetHub,
    copyableAssets
  } = useAssetCopierContext();
  const {
    onClickDone
  } = props;
  const nextButtonDisabled = !selectedTargetHub;
  if (currentStep === 'AWAITING_ACTION') {
    return null;
  }
  if (currentStep === 'CHOOSE_DESTINATION') {
    return /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        disabled: nextButtonDisabled,
        onClick: () => void goToNextStep(),
        "data-test-id": "asset-copier-panel-next-button",
        marginInlineStart: "auto",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.next"
        })
      })
    });
  }
  if (currentStep === 'VALIDATION') {
    return null;
  }
  if (currentStep === 'CONFIRM_SELECTION') {
    return /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "secondary",
        onClick: () => {
          setCurrentStep('CHOOSE_DESTINATION');
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.back"
        })
      }), copyableAssets.length === 0 ? /*#__PURE__*/_jsx(Button, {
        use: "tertiary",
        onClick: onClickDone,
        "data-test-id": "asset-copier-panel-close-button",
        marginInlineStart: "auto",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.close"
        })
      }) : /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: () => void goToNextStep(),
        "data-test-id": "asset-copier-panel-confirm-button",
        marginInlineStart: "auto",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.confirm"
        })
      })]
    });
  }
  if (currentStep === 'SUCCESS' || currentStep === 'ERROR') {
    return /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: onClickDone,
        "data-test-id": "asset-copier-panel-done-button",
        marginInlineStart: "auto",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.done"
        })
      })
    });
  }
}
export default AssetCopierPanelFooter;